import React from 'react';
import MenuItem from './MenuItem';

const MenuGrid = ({ items }) => {
  if (items.length === 0) {
    return (
      <div data-component-path="client/src/components/MenuGrid.jsx" data-component-line="7:7" data-component-id="client/src/components/MenuGrid.jsx:7:7" className="text-center py-16">
        <p data-component-path="client/src/components/MenuGrid.jsx" data-component-line="8:9" data-component-id="client/src/components/MenuGrid.jsx:8:9" className="text-xl text-gray-500">No items match your selected filters</p>
      </div>
    );
  }

  return (
    <div data-component-path="client/src/components/MenuGrid.jsx" data-component-line="15:5" data-component-id="client/src/components/MenuGrid.jsx:15:5" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {items.map(item => (
        <MenuItem key={item.id} item={item} />
      ))}
    </div>
  );
};

export default MenuGrid;